import { styled } from '@mui/joy';
import Stack from '@mui/joy/Stack';

export const BasePaper = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: `calc(100% + ${theme.spacing(1)})`,
  right: 0,
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.isDarkMode
    ? theme.palette.neutral[450]
    : theme.palette.neutral[50],
  boxShadow:
    'var(--joy-shadowRing, 0 0 #000),0px 2px 8px -2px rgba(var(--joy-shadowChannel, 21 21 21) / var(--joy-shadowOpacity, 0.08)),0px 6px 12px -2px rgba(var(--joy-shadowChannel, 21 21 21) / var(--joy-shadowOpacity, 0.08))',
}));
